@if (model?.news?.length) {
  <div class="tile mb-4">
    @if (model?.name) {
      <h5 class="mb-4 font-medium">
        {{ 'instrument-detail.instrument-news.headline' | transloco: { name: model.name } }}
      </h5>
    }
    @for (item of model?.news; track i; let i = $index) {
      <strong class="font-medium">
        {{ item.title }}
      </strong>
      <div class="font-light mt-2 mb-2">
        {{ item.description }}
      </div>
      <div class="d-flex justify-content-between">
        <div class="text-size-large font-light">{{ item.publicationDate | date: 'dd.MM.yy HH:mm' }}</div>
        <a class="link-secondary" target="_blank" rel="noopener noreferrer" [href]="item.sourceUri">
          {{ 'instrument-detail.instrument-news.more' | transloco }}
        </a>
      </div>
      <hr [class.d-none]="i === model?.news.length - 1" />
    }
  </div>
}
